import {useSelector} from 'react-redux';

function useGetProfiles() {
  return useSelector((state: any) => state.profiles.profile);
}

export default useGetProfiles;
